import {Component, Inject, OnInit} from '@angular/core';
import {TestService} from '../../../services/api/test.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Test} from '../../../data/models/test/test';
import {Question} from '../../../data/models/test/question';
import {QuestionService} from '../../../services/api/question.service';
import {QUESTION_TYPES} from '../../../../constants/questionTypes';

@Component({
  selector: 'app-test-activate-dialog',
  templateUrl: './test-activate-dialog.component.html',
  styleUrls: ['./test-activate-dialog.component.css']
})
export class TestActivateDialogComponent implements OnInit {

  test: Test;

  questions!: Question[];
  questionsErrors: string[] = [];
  questionsChecked = false;

  constructor(
    private testService: TestService,
    private questionService: QuestionService,
    public dialogRef: MatDialogRef<TestActivateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      test: Test,
    },
  ) {
    this.test = data.test;
    this.checkQuestions();
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testService.activateTest(this.test.id)
      .then(test => {
        this.dialogRef.close(test);
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  checkQuestions(): void {
    this.questionService.getQuestions(this.test.id)
      .then(questions => {
        this.questions = questions;
        if (questions.length === 0) {
          this.questionsErrors.push('В ' + (this.test.type === 'POLL' ? 'опросе' : 'тесте') + ' нет вопросов');
          this.questionsChecked = true;
          return;
        }

        const questionsWithoutOptions = [];
        const questionsWithOneOption = [];
        const questionsWithoutCorrectOptions = [];
        const questionsWithEmptyTextAnswer = [];

        let questionNumber = 1;
        for (const question of questions) {
          if (question.type.techId === QUESTION_TYPES.SINGLE_ANSWER ||
            question.type.techId === QUESTION_TYPES.MULTIPLE_ANSWER) {
            if (!question.options || question.options.length === 0) {
              questionsWithoutOptions.push(questionNumber);
            } else if (question.options.length === 1) {
              questionsWithOneOption.push(questionNumber);
            } else if (question.options.findIndex(option => option.isCorrect) === -1) {
              questionsWithoutCorrectOptions.push(questionNumber);
            }
          }
          if (question.type.techId === QUESTION_TYPES.TEXT_ANSWER) {
            if (question.answer.text.length === 0) {
              questionsWithEmptyTextAnswer.push(questionNumber);
            }
          }
          questionNumber++;
        }

        if (questionsWithoutOptions.length > 0) {
          this.questionsErrors.push(`Вопросы без вариантов ответа: ${questionsWithoutOptions.join(', ')}.`);
        }
        if (questionsWithOneOption.length > 0) {
          this.questionsErrors.push(`Вопросы с одним вариантом ответа: ${questionsWithOneOption.join(', ')}.`);
        }

        if(this.test.type == "POLL" || this.test.type == "ANON") {
          this.questionsChecked = true;
          return;
        }

        if (questionsWithoutCorrectOptions.length > 0) {
          this.questionsErrors.push(`Вопросы без правильного варианта ответа: ${questionsWithoutCorrectOptions.join(', ')}.`);
        }
        if (questionsWithEmptyTextAnswer.length > 0) {
          this.questionsErrors.push(`Вопросы с пустым открытым ответом: ${questionsWithEmptyTextAnswer.join(', ')}.`);
        }

        this.questionsChecked = true;
      });
  }

}
